/**
 * Constantes globales de la aplicación
 */

// Roles de usuario
export const ROLES = {
  TRABAJADOR: "trabajador",
  ADMIN: "admin",
  GLOBAL_ADMIN: "global_admin",
};

// Tipos de fichaje
export const FICHAJE_TIPOS = {
  ENTRADA: "entrada",
  SALIDA: "salida",
  AUSENCIA: "ausencia",
};

// Estados de fichaje
export const FICHAJE_ESTADOS = {
  COMPLETO: "completo",      // Tiene entrada y salida
  INCOMPLETO: "incompleto",  // Solo tiene entrada
  AUSENTE: "ausente",        // Registró ausencia
};

// Rutas de la aplicación
export const ROUTES = {
  // Públicas
  HOME: "/",
  LOGIN: "/login",
  LANDING: "/landing",
  POLITICA_PRIVACIDAD: "/politica-privacidad",
  
  // Trabajador
  TRABAJADOR: "/trabajador",
  FICHAR: "/fichar",
  
  // Admin Empresa
  ADMIN_HOME: "/admin-home",
  ADMIN: "/admin",
  EMPRESAS_DETAIL: "/empresas/:id",
  
  // Admin Global
  GLOBAL_ADMIN: "/global-admin",
  EMPRESAS: "/empresas",
  USUARIOS: "/usuarios",
  FICHAJES: "/fichajes",
};

// Mensajes de error comunes

export const SUCCESS_MESSAGES = {
  JORNADA_CREADA: "Jornada creada correctamente",
  JORNADA_EDITADA: "Jornada actualizada correctamente",
  JORNADA_ELIMINADA: "Jornada eliminada correctamente",
  GRUPO_CREADO: "Grupo de trabajo creado correctamente",
  GRUPO_EDITADO: "Grupo de trabajo actualizado correctamente",
  GRUPO_ELIMINADO: "Grupo de trabajo eliminado correctamente",
  JORNADA_ASOCIADA: "Jornada asociada correctamente",
};

export const ERROR_MESSAGES = {
  UNAUTHORIZED: "No autorizado",
  INVALID_DATE: "Fecha inválida",
  NETWORK_ERROR: "Error de conexión",
  GENERIC_ERROR: "Ha ocurrido un error",
  VALIDACION_SOLICITUD_FECHA_INICIO_POSTERIOR: "La fecha de inicio no puede ser posterior a la fecha de fin",
  VALIDACION_SOLICITUD_FECHA_ANTERIOR_HOY: "No puedes solicitar vacaciones o ausencias en días anteriores a hoy",
  VALIDACION_SOLICITUD_SOLAPADA: "Ya existe una solicitud de vacaciones o ausencia para esas fechas",
  JORNADA_NOMBRE_REQUERIDO: "El nombre de la jornada es obligatorio",
  JORNADA_NO_ENCONTRADA: "Jornada no encontrada",
  GRUPO_NOMBRE_REQUERIDO: "El nombre del grupo es obligatorio",
  GRUPO_NO_ENCONTRADO: "Grupo de trabajo no encontrado",
  JORNADA_ASOCIACION_ERROR: "Error al asociar jornada",
};

// Mensajes de validación
export const VALIDATION_MESSAGES = {
  INVALID_NAME: "Nombre inválido: solo letras, espacios, guiones y apóstrofes",
  INVALID_SECOND_NAME: "Segundo nombre inválido: solo letras, espacios, guiones y apóstrofes",
  INVALID_FIRST_SURNAME: "Primer apellido inválido: solo letras, espacios, guiones y apóstrofes",
  INVALID_SECOND_SURNAME: "Segundo apellido inválido: solo letras, espacios, guiones y apóstrofes",
  INVALID_DNI: "Documento inválido. Formatos aceptados: DNI (12345678A), NIE (X1234567A), Pasaporte (ABC123456) u otro documento (mínimo 5 caracteres)",
  INVALID_PHONE: "Teléfono inválido: debe tener 9 dígitos (opcional)",
  INVALID_EMAIL: "Email inválido",
  INVALID_PASSWORD: "La contraseña debe tener al menos 6 caracteres",
  INVALID_PASSWORD_EDIT: "Si cambias la contraseña, debe tener al menos 6 caracteres",
  EMPRESA_REQUIRED: "Debes seleccionar una empresa (excepto para global admin)",
};


// Colores del tema
export const THEME_COLORS = {
  PRIMARY: "#4F46E5", // Indigo
  SECONDARY: "#7C3AED", // Purple
  SUCCESS: "#10B981", // Green
  ERROR: "#EF4444", // Red
  WARNING: "#F59E0B", // Amber
  INFO: "#3B82F6", // Blue
};
